module.exports = __webpack_public_path__ + "static/media/stellar.7b38cc0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stellar.jpg
// module id = 244
// module chunks = 0